import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable, throwError, of } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable()
export class UploadDocsService {


    readonly apiPath = environment.baseUrl + 'upload-docs/';
    readonly headers = { headers: new HttpHeaders({ 'No-Auth': 'True' }) };
    constructor(
        private http: HttpClient,
    ) { }


    getInfos(token: string): Observable<any> {
        return this.http.get(this.apiPath + 'get-type/'+token) as Observable<number>;
    }

    uploadFiles(token: string, formdata: FormData): Observable<any> {
      return this.http.post(this.apiPath + 'upload/'+token, formdata) as Observable<number>;
    }




}
